var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 186,
    viewBox: "0 0 237 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4721_14205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.422 167.71C27.8165 179.569 41.388 184.66 41.388 184.66C41.388 184.66 44.5919 170.524 38.1974 158.665C31.8028 146.806 18.2313 141.715 18.2313 141.715C18.2313 141.715 15.0274 155.851 21.422 167.71Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8163 163.808C37.361 170.754 41.8073 184.55 41.8073 184.55C41.8073 184.55 27.5358 187.085 15.991 180.139C4.44625 173.194 0 159.398 0 159.398C0 159.398 14.2715 156.863 25.8163 163.808Z",
    fill: "#75B09C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.284 162.279H64.4551V161.403H185.407V118.894H74.6969L69.3187 107.69L70.109 107.311L75.2484 118.017H186.284V162.279Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6687 183.754C85.7513 183.754 89.8716 179.634 89.8716 174.552C89.8716 169.469 85.7513 165.349 80.6687 165.349C75.5861 165.349 71.4658 169.469 71.4658 174.552C71.4658 179.634 75.5861 183.754 80.6687 183.754Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.383 183.754C176.465 183.754 180.585 179.634 180.585 174.552C180.585 169.469 176.465 165.349 171.383 165.349C166.3 165.349 162.18 169.469 162.18 174.552C162.18 179.634 166.3 183.754 171.383 183.754Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.314 104.433H62.3777L32.748 7.58398H229.828L229.648 8.15381L199.314 104.433ZM63.0261 103.557H198.671L228.633 8.46043H33.9326L63.0261 103.557Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M188.625 99.3927H68.3491L42.3242 13.499H215.426L215.269 14.0048L188.625 99.3927Z",
    fill: "#89CFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.979 36.9463H42.3223V37.8228H219.979V36.9463Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.805 69.2363H52.2012V70.1128H209.805V69.2363Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.723 8.02246H130.847V103.995H131.723V8.02246Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.963 7.99533L164.672 103.966L165.547 104.023L171.838 8.05268L170.963 7.99533Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6248 7.99377L90.75 8.05078L97.0051 104.024L97.8798 103.967L91.6248 7.99377Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.512 184.31H0V185.339H236.512V184.31Z",
    fill: "#2F2E41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4721_14205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 186,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProducts);
export default __webpack_public_path__ + "static/media/noProducts.e315e18efd0ab90e6d36e73eeccc6fd6.svg";
export { ForwardRef as ReactComponent };